import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconFile = ({
    width = '16',
    height = '16',
    className = undefined,
    ...rest
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        className={classnames(css.main, css.colored, className)}
        {...rest}
    >
        <path d="M12 15H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.401a3.86 3.86 0 0 1 2.729 1.13l1.74 1.74A3.86 3.86 0 0 1 14 6.599V13a2 2 0 0 1-2 2zm-.5-3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1h7zm0-2a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1h7zm0-2a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1h7zM7 5.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5zM6.5 3h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
    </svg>
);

export default IconFile;
